<script type="text/javascript">
    import { mapGetters } from 'vuex'
    import NavBar from './root/navbar'
    import SideBar from './root/sidebar'
    export default {
        components: {
            NavBar, SideBar
        },
        computed: {
            ...mapGetters(['shouldShowNavigation']),
        },
         
    }
</script>
<template>
  <div id="app"> 
        <side-bar v-if="shouldShowNavigation"></side-bar>
           <div class="page-container">
           <nav-bar v-if="shouldShowNavigation"></nav-bar>     
           <router-view :key="$route.fullPath"></router-view>
         </div>   
  </div>  
</template>



// WEBPACK FOOTER //
// main.vue?0f08be7c